import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSliderLoading, EGetSliderActionType } from './types';
import { ISliderNameAndAudienceType } from '../../../types/slider';

export const getSliderLoading: (data: ISliderNameAndAudienceType) => TGetSliderLoading = actionGenerator<
  EGetSliderActionType.Loading,
  ISliderNameAndAudienceType
>(EGetSliderActionType.Loading);
